import { put, takeLatest, cancel } from 'redux-saga/effects';
import * as unresolvedList from '../complaintUnResolvedList';
import * as getLoggedUser from '../../profiles/get-logged-user';

function* runReportsWatcher() {
  const task = yield takeLatest(
    [unresolvedList.consts.SUCCEED, unresolvedList.consts.REJECTED],
    handleRequestFinish,
  );

  function* handleRequestFinish({ type }) {
    const isMenuShown = type === unresolvedList.consts.SUCCEED;
    yield put(unresolvedList.actions.toggleMenuVisibility(isMenuShown));
    yield cancel(task);
  }
}

export default function* reportMenuVisibility() {
  yield takeLatest([getLoggedUser.consts.SUCCEED], runReportsWatcher);
}



// WEBPACK FOOTER //
// ./src/redux/complaints/watchers/reportMenuVisibility.js